import accountApi from "../../../api/account/account";

const state = {
  monLst: []
};

const getters = {};

const mutations = {};

const actions = {
  // 获取用户详情
  getUserDtl({ state }, { params, callback }) {
    console.log(state);
    accountApi.getUserDtlApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 提交用户信息
  submitUserInfo({ state }, { params, callback }) {
    console.log(state);
    accountApi.submitUserInfoApi({ params, callback }, res => {
      callback(res);
    });
  },
  matchPassword({state}, {params, callback}) {
    console.log(state)
    accountApi.matchPasswordApi(({params, callback}), (res) => {
      callback(res)
    })
  },
  changePassword({state}, {params, callback}) {
    console.log(state)
    accountApi.changePasswordApi(({params, callback}), (res) => {
      callback(res)
    })
  },
  // 获取佣金列表按月
  getCosByMon({ state }, { callback }) {
    console.log(state);
    accountApi.getCosByMonApi({ callback }, res => {
      callback(res);
    });
  },
  // 获取佣金列表按年
  getCosByYear({ state }, { callback }) {
    console.log(state);
    accountApi.getCosByYearApi({ callback }, res => {
      callback(res);
    });
  },
  // 获取当月销售个数
  getSoldList({ state }, { callback }) {
    console.log(state);
    accountApi.getSoldListApi({ callback }, res => {
      callback(res);
    });
  },
  // 获取invoice消息数
  getInvoiceNums({ state }, { callback }) {
    console.log(state);
    accountApi.getInvoiceNumsApi({ callback }, res => {
      callback(res);
    });
  },
  // retrieveMinimalUserForRevealPriceList
  retrieveMinimalUserForRevealPriceList({ state }, { callback }) {
    accountApi.retrieveMinimalUserForRevealPriceListApi({ callback }, res => {
      callback(res);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/account/account.js